export namespace CouponConst
{
  export const PrefixEnterprisingTEC23 = "TEC24";
}